<script setup>
  const {sectors, values, errors, setValues, prefillUserInfo: prefill } = defineProps({
    sectors: { type: Object, required: true },
    values: { type: Object, required: true },
    errors: { type: Object, required: true },
    setValues: { type: Function, required: true },
    prefillUserInfo: { type: Boolean, default: true }
  })

  const { user } = useUser()
  const initSectorsValues = prefill ? user.value.candidate.sectors.map(sector => sector.id) : []
  const initSkillsValues = prefill ? user.value.candidate.skills.map(skill => skill.id) : []

  const getSkillsOptions = selectedSectors => {
    if (!sectors) return []

    return selectedSectors.reduce((acc, sectorId) => {
      const sector = sectors.find(sector => sector.id === sectorId)
      return acc.concat(sector.skills)
    }, [])
  }

  const skillsOptions = ref([])
  watch(
    () => sectors,
    value => {
      if (prefill && user.value.candidate.sectors.length > 0) {
        skillsOptions.value = getSkillsOptions(user.value.candidate.sectors.map(sector => sector.id))
      }
    },
    { immediate: true }
  )

  const onDomainChange = (selectedSectors, formValues, setValues) => {
    skillsOptions.value = getSkillsOptions(selectedSectors)
    if (formValues.skills) {
      const filteredSelectedSkills = Object.values(formValues.skills).filter(selectedSkill => {
        return skillsOptions.value.map(skillOption => skillOption.id).includes(selectedSkill)
      })
      setValues({ skills: filteredSelectedSkills })
    }
  }
</script>

<template>
  <div>
    <FormField
      class="basis-full p-2"
      id="sectors"
      :error="errors.sectors"
      placeholder="Dans quels domaines ? (3 max)"
      name="sectors"
      required
      multiple
      maxlength="3"
      type="select"
      :value="initSectorsValues"
      :options="sectors ? sectors.map(sector => ({ label: sector.name, value: sector.id })) : []"
      @select="value => onDomainChange(value, values, setValues)"
    />
    <FormField
      class="basis-full p-2"
      id="skills"
      v-if="values.sectors"
      :error="errors.skills"
      placeholder="Quelles compétences ?"
      name="skills"
      required
      multiple
      type="select"
      :value="initSkillsValues"
      :options="
        skillsOptions.length === 0
          ? [{ label: 'Aucune compétence à sélectionner', value: '' }]
          : skillsOptions.map(skill => ({ label: skill?.name, value: skill?.id }))
      "
    />
  </div>
</template>
